import { axiosInstance as request } from '@api/rest.service'
import { downloadFile } from '@lib/generic.utils'

const api = '/progress-bar/tasks'

/**
 * @description GET /progress-bar/tasks/count/{task}
 * @returns {AxiosPromise<any>}
 */
export const GET_TASK_COUNT = task => request.get(`${api}/count/${task}`)

/**
 * @description GET /progress-bar/tasks/count/{task}/subscription-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_TASK_COUNT_FOR_SUB_PERIOD = (task, periodId) =>
  request.get(`${api}/count/${task}/subscription-periods/${periodId}`)

/**
 * @description GET /progress-bar/tasks/data/plan-workflow?paginated=true (+ ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_TASK_DATA_PLAN_WORKFLOW = params => request.get(`${api}/data/plan-workflow?paginated=true`, { params })

/**
 * @description GET /progress-bar/tasks/data/{task}
 * @returns {AxiosPromise<any>}
 */
export const GET_TASK_DATA = task => request.get(`${api}/data/${task}`)

/**
 * @description GET /progress-bar/tasks/data/{task}/subscription-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_TASK_DATA_FOR_SUB_PERIOD = (task, periodId) =>
  request.get(`${api}/data/${task}/subscription-periods/${periodId}`)

/**
 * @description GET /progress-bar/tasks/quick-view/{task}/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_TASK_QUICK_VIEW = (task, id) => request.get(`${api}/quick-view/${task}/${id}`)

/**
 * @description PUT /progress-bar/tasks/quick-view/vendor-payments/vendor-invoices/{id}
 * @returns {AxiosPromise<any>}
 */
export const VENDOR_PAYMENTS_TASK_UPDATE_INVOICE = (id, payload) =>
  request.put(`${api}/quick-view/vendor-payments/vendor-invoices/${id}`, payload)

/**
 * @description POST /progress-bar/tasks/attachments/{task}/{attachment_name}
 * @returns {AxiosPromise<any>}
 */
export const TASK_PREVIEW_ATTACHMENT = (task, name, payload) =>
  request.post(`${api}/attachments/${task}/${name}`, payload, { responseType: 'arraybuffer' }).then(downloadFile)

/**
 * @description POST /progress-bar/tasks/process/{task}/{id}
 * @returns {AxiosPromise<any>}
 */
export const PROCESS_TASK = (task, id, payload) => request.post(`${api}/process/${task}/${id}`, payload)

/**
 * @description PUT /progress-bar/tasks/process/{task}/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_TASK = (task, id, payload) => request.put(`${api}/process/${task}/${id}`, payload)

/**
 * @description POST /progress-bar/tasks/dismiss/{task}/{id}
 * @returns {AxiosPromise<any>}
 */
export const DISMISS_TASK = (task, id, payload) => request.post(`${api}/dismiss/${task}/${id}`, payload)
